import {Injectable} from '@angular/core';
import {UtilsService} from './utils.service';
import * as moment from 'moment';
import * as Handsontable from 'handsontable';

@Injectable({
  providedIn: 'root'
})

export class UtilsTableService {

  constructor(private _utils: UtilsService) {
  }

  // todo registro de validators

  addMoreRows(hotInstance, rowsLength) {
    return hotInstance.alter('insert_row', hotInstance.countRows(), rowsLength);
  }

  totalReadOnly(hotInstance, columns, row, col) {
    const prop = {};
    const rowsLength = hotInstance.countRows();

    if (row === rowsLength - 1) {
      prop['readOnly'] = true;
      if (col === 0) {
        prop['renderer'] = function (instance, td, r, c, v) {
          arguments[5] = 'TOTAL';
          td.style.fontWeight = 'bold';
          Handsontable.renderers.TextRenderer.apply(this, arguments);
        };
      }
    } else if (!columns[col].readOnly && !hotInstance.getSettings().readOnly) {
      prop['readOnly'] = false;
      if (col === 0) {
        prop['renderer'] = function (instance, td, r, c, v) {
          if (td.innerHTML === 'TOTAL') {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.innerHTML = null;
          } else {
            Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
          }
        };
      }
    }

    return prop;
  }

  calcTotalColumn(hotInstance, columns, colChanged?) {
    for (const col of columns) {
      let rowLength = hotInstance.countRows();
      const minRows = hotInstance.getSettings().minRows;
      if (minRows > rowLength) {
        rowLength = minRows;
      }
      const colIndex = hotInstance.propToCol(col.data);
      if ((!colChanged || colChanged === col.data) && col.totalType) {
        const columnValues = Object.assign([], hotInstance.getDataAtCol(colIndex));
        columnValues.splice(-1, 1);
        const result = this._utils.calcTotalFromArray(columnValues, col.totalType);
        if (!result) {
          hotInstance.setDataAtCell(rowLength - 1, colIndex, null, 'setTotal');
          continue;
        }
        hotInstance.setDataAtCell(rowLength - 1, colIndex, result, 'setTotal');
      }
    }
  }

  calcTotalColumnOnLoad(columns, dataItens) {
    const objResult = {};
    for (let colIndex = 0; colIndex < columns.length; colIndex++) {
      const totalType = columns[colIndex]['totalType'], columnValues = [];
      for (const dataItem of dataItens) {
        columnValues.push(dataItem[columns[colIndex]['data']]);
      }
      const result = this._utils.calcTotalFromArray(columnValues, totalType);
      if (!result) {
        continue;
      }
      objResult[columns[colIndex]['data']] = result;
    }
    dataItens.splice(dataItens.length, 1, objResult);
    return dataItens;
  }

  calcTotalMultipleColumns(hotInstance, columns, colChanged?) {
    let multipleResults = 0;
    for (const col of columns) {
      let result;
      let rowLength = hotInstance.countRows();
      const minRows = hotInstance.getSettings().minRows;
      if (minRows > rowLength) {
        rowLength = minRows;
      }
      const colIndex = hotInstance.propToCol(col.data);
      if ((!colChanged || colChanged === col.data) && col.totalType) {
        const columnValues = Object.assign([], hotInstance.getDataAtCol(colIndex));
        columnValues.splice(-1, 1);
        result = this._utils.calcTotalFromArray(columnValues, col.totalType);
        if (!result) {
          result = 0;
        }
        multipleResults = +(multipleResults + result).toFixed(10);
      }
    }
    return multipleResults;
  }

  calcTotalMultipleColumnsOnLoad(columns, dataItens) {
    let multipleResults = 0;
    for (let colIndex = 0; colIndex < columns.length; colIndex++) {
      const totalType = columns[colIndex]['totalType'], columnValues = [];
      for (const dataItem of dataItens) {
        columnValues.push(dataItem[columns[colIndex]['data']]);
      }
      let result = this._utils.calcTotalFromArray(columnValues, totalType);
      if (!result) {
        result = 0;
      }
      multipleResults = +(multipleResults + result).toFixed(10);
    }
    return multipleResults;
  }

  removeTotalMinRows(hotInstance, columns) {
    const rowsLength = hotInstance.countRows();
    const columnsLength = hotInstance.countCols();
    const minRows = hotInstance.getSettings().minRows;
    if (minRows > rowsLength) {
      for (let cellIndex = 0; cellIndex < columnsLength; cellIndex++) {
        hotInstance.setDataAtCell(rowsLength - 1, cellIndex, null, 'clearTotal');
      }
    }
    this.calcTotalColumn(hotInstance, columns);
  }

  invalidDuplicate(hotInstance, colIndex, value) {
    if (!value) {
      return true;
    }
    const column = hotInstance.getDataAtCol(colIndex);
    const data = Object.assign([], column);
    const index = data.indexOf(value);
    data.splice(index, 1);
    const secondIndex = data.indexOf(value);
    return secondIndex === -1;
  }

  invalidDuplicate2(hotInstance, indexType, indexInverse, value, type?) {
    if (!value) {
      return true;
    }
    const dataObj = type === 'col' || !type ? hotInstance.getDataAtCol(indexType) : hotInstance.getDataAtRow(indexType);
    const data = Object.assign([], dataObj);
    data.splice(indexInverse, 1, value);
    const dataIndex = data.indexOf(value);
    data.splice(dataIndex, 1);
    const secondIndex = data.indexOf(value);
    return secondIndex === -1;
  }

  getRowOrColLength(hotInstance, index, type?) {
    const obj = type === 'row' || !type ? hotInstance.getDataAtRow(index) : hotInstance.getDataAtCol(index);
    let length = 0;
    for (const data of obj) {
      if (data || data === 0) {
        length++;
      }
    }
    return length;
  }

  isEmptyTable(hotInstance) {
    const data = hotInstance.getData();
    let isEmptyTable = true;
    for (let rowIndex; rowIndex < data; rowIndex++) {
      const rowLength = this.getRowOrColLength(hotInstance, rowIndex);
      if (rowLength !== 0) {
        isEmptyTable = false;
      }
    }
    return isEmptyTable;
  }

  hasInvalidFields(hotInstance) {
    const colsLength = hotInstance.countCols();
    const rowsLength = hotInstance.countRows();
    let valid = false;
    for (let r = 0; r < rowsLength; r++) {
      for (let c = 0; c < colsLength; c++) {
        const cellMeta = hotInstance.getCellMeta(r, c);
        if (cellMeta.hasOwnProperty('valid') && cellMeta['valid'] === false) {
          valid = true;
        }
      }
    }
    return valid;
  }

  convertObjToRow(columns, dataItem) {
    const row = {};
    for (const column of columns) {
      for (const key in dataItem) {
        if (dataItem.hasOwnProperty(column.data)) {
          if (column.data === key) {
            if (dataItem[column.data] || dataItem[column.data] === 0) {
              if (column.type === 'autocomplete' && column.propToShow && column.propToSave) {
                row[column.data] = this._utils.getPropObjFromArray(column.sourceToFilter, column.propToShow, column.propToSave, dataItem[column.data]);
              } else if (column.type === 'date' && column.dateFormatConvert) {
                row[column.data] = moment(dataItem[column.data], column.dateFormatConvert).format(column.dateFormat);
              } else {
                row[column.data] = dataItem[key];
              }
            } else {
              row[column.data] = null;
            }
          }
        } else {
          row[column.data] = null;
        }
      }
    }
    return row;
  }

  convertRowToObj(columns, row) {
    const rowObj = {};
    for (let rowIndex = 0; rowIndex < row.length; rowIndex++) {
      const column = columns[rowIndex];
      if (row[rowIndex] || row[rowIndex] === 0) {
        if (column.type === 'autocomplete' && column.propToShow && column.propToSave) {
          rowObj[column.data] = this._utils.getPropObjFromArray(column.sourceToFilter, column.propToSave, column.propToShow, row[rowIndex]);
        } else if (column.type === 'date' && column.dateFormatConvert) {
          rowObj[column.data] = moment(row[rowIndex], column.dateFormat).format(column.dateFormatConvert);
        } else {
          rowObj[column.data] = row[rowIndex];
        }
      } else {
        rowObj[column.data] = null;
      }
    }
    return rowObj;
  }
}
